import styled, { css } from 'styled-components';
import { space, color } from 'styled-system';

const IconStyles = styled.svg`
  ${space}
  ${color}

  ${props =>
    props.rotate !== undefined &&
    css`
      transform: rotate(${props.rotate}deg) !important;
    `};

  ${props =>
    props.mr !== undefined &&
    css`
      margin-right: ${props.theme.space[props.mr]} !important;
    `};
`;

export default IconStyles;
